import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { usePaginationItems } from './hooks/usePaginationItems.js';
import { preventDefault } from './helpers/dom.js';
import { defaultLabelBehaviour } from './labelBehaviour.js';
/* legacy - may be removed */
export var bootstrap4PaginationPreset = {};
export var bootstrap5PaginationPreset = {};
export default process.env.NODE_ENV !== 'production' ? memo(ResponsivePaginationDev) : memo(ResponsivePagination);
function ResponsivePaginationDev(props) {
  checkLegacyProps(props);
  return ResponsivePagination(props);
}
/* eslint-disable jsx-a11y/anchor-is-valid */
function ResponsivePagination(_ref) {
  var current = _ref.current,
    total = _ref.total,
    handlePageChange = _ref.onPageChange,
    maxWidth = _ref.maxWidth,
    narrowBehaviour = _ref.narrowBehaviour,
    className = _ref.className,
    _ref$extraClassName = _ref.extraClassName,
    extraClassName = _ref$extraClassName === void 0 ? 'justify-content-center' : _ref$extraClassName,
    _ref$pageItemClassNam = _ref.pageItemClassName,
    pageItemClassName = _ref$pageItemClassNam === void 0 ? 'page-item' : _ref$pageItemClassNam,
    _ref$pageLinkClassNam = _ref.pageLinkClassName,
    pageLinkClassName = _ref$pageLinkClassNam === void 0 ? 'page-link' : _ref$pageLinkClassNam,
    _ref$activeItemClassN = _ref.activeItemClassName,
    activeItemClassName = _ref$activeItemClassN === void 0 ? 'active' : _ref$activeItemClassN,
    _ref$disabledItemClas = _ref.disabledItemClassName,
    disabledItemClassName = _ref$disabledItemClas === void 0 ? 'disabled' : _ref$disabledItemClas,
    navClassName = _ref.navClassName,
    previousClassName = _ref.previousClassName,
    nextClassName = _ref.nextClassName,
    previousLabel = _ref.previousLabel,
    nextLabel = _ref.nextLabel,
    ariaPreviousLabel = _ref.ariaPreviousLabel,
    ariaNextLabel = _ref.ariaNextLabel,
    _ref$renderNav = _ref.renderNav,
    renderNav = _ref$renderNav === void 0 ? true : _ref$renderNav,
    _ref$ariaCurrentAttr = _ref.ariaCurrentAttr,
    ariaCurrentAttr = _ref$ariaCurrentAttr === void 0 ? true : _ref$ariaCurrentAttr,
    _ref$linkHref = _ref.linkHref,
    linkHref = _ref$linkHref === void 0 ? 'hash' : _ref$linkHref,
    _ref$labelBehaviour = _ref.labelBehaviour,
    getLabel = _ref$labelBehaviour === void 0 ? defaultLabelBehaviour : _ref$labelBehaviour;
  var _usePaginationItems = usePaginationItems(current, total, maxWidth, {
      narrowBehaviour: narrowBehaviour,
      previousLabel: previousLabel,
      nextLabel: nextLabel,
      ariaPreviousLabel: ariaPreviousLabel,
      ariaNextLabel: ariaNextLabel,
      renderNav: renderNav
    }),
    items = _usePaginationItems.items,
    ref = _usePaginationItems.ref,
    clearCache = _usePaginationItems.clearCache;
  useEffect(function () {
    return function () {
      return clearCache();
    };
  }, [clearCache, className, pageItemClassName, pageLinkClassName, activeItemClassName, disabledItemClassName, navClassName, previousClassName, nextClassName]);
  if (items.length === 0) return null;
  function getContainerClassName() {
    if (className !== undefined) {
      return className;
    } else if (extraClassName) {
      return "pagination ".concat(extraClassName);
    } else {
      return 'pagination';
    }
  }
  return React.createElement("ul", {
    className: getContainerClassName(),
    ref: ref
  }, items.map(function (item) {
    return item.gotoPage !== undefined ?
    // item = ClickableItem
    React.createElement("li", {
      key: item.key,
      className: classNames([pageItemClassName, item.active && activeItemClassName, item.type === 'next' && (nextClassName !== null && nextClassName !== void 0 ? nextClassName : navClassName), item.type === 'previous' && (previousClassName !== null && previousClassName !== void 0 ? previousClassName : navClassName)]),
      "aria-current": item.active && ariaCurrentAttr ? 'page' : undefined
    }, React.createElement("a", {
      className: pageLinkClassName,
      href: linkHref === 'hash' ? '#' : undefined,
      onClick: preventDefault(function () {
        return handlePageChange(item.gotoPage);
      }),
      "aria-label": item.a11yLabel
    }, getLabel(item))) :
    // item = NonClickableItem
    React.createElement("li", {
      key: item.key,
      className: classNames([pageItemClassName, disabledItemClassName, item.type === 'next' && (nextClassName !== null && nextClassName !== void 0 ? nextClassName : navClassName), item.type === 'previous' && (previousClassName !== null && previousClassName !== void 0 ? previousClassName : navClassName)]),
      "aria-hidden": item.a11yHidden
    }, React.createElement("span", {
      className: pageLinkClassName,
      "aria-label": item.a11yLabel
    }, getLabel(item)));
  }));
}
function classNames(names) {
  return names.filter(function (name) {
    return name;
  }).join(' ');
}
ResponsivePagination.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  maxWidth: PropTypes.number,
  narrowBehaviour: PropTypes.func,
  className: PropTypes.string,
  extraClassName: PropTypes.string,
  pageItemClassName: PropTypes.string,
  pageLinkClassName: PropTypes.string,
  activeItemClassName: PropTypes.string,
  disabledItemClassName: PropTypes.string,
  disabledLinkClassName: PropTypes.string,
  navClassName: PropTypes.string,
  previousClassName: PropTypes.string,
  nextClassName: PropTypes.string,
  previousLabel: PropTypes.string,
  nextLabel: PropTypes.string,
  ariaPreviousLabel: PropTypes.string,
  ariaNextLabel: PropTypes.string,
  renderNav: PropTypes.bool,
  ariaCurrentAttr: PropTypes.bool,
  linkHref: PropTypes.oneOf(['hash', 'omit']),
  labelBehaviour: PropTypes.func
};
var legacyUsageWarnings = [];
function checkLegacyProps(props) {
  for (var _i = 0, _arr = ['srOnlyClassName', 'a11yActiveLabel', 'narrowStrategy']; _i < _arr.length; _i++) {
    var legacyProp = _arr[_i];
    if (props[legacyProp] !== undefined && !legacyUsageWarnings.includes(legacyProp)) {
      console.warn("react-responsive-pagination: '".concat(legacyProp, "' prop no longer supported, please see migration guide: https://react-responsive-pagination.elantha.com/migration/"));
      legacyUsageWarnings.push(legacyProp);
    }
  }
}